/**
 * eSchedule visit e-communication merge tags — must match legacy CTMS replacement
 * tokens ({SingleBraces}) used when appointment emails/SMS are sent.
 */
export const SCHEDULE_ECOMM_MERGE_TAGS = [
  { tag: "{StudyName}", description: "Study name" },
  { tag: "{VisitName}", description: "Visit name" },
  { tag: "{VolunteerName}", description: "Participant name" },
  { tag: "{Date}", description: "Appointment date" },
  { tag: "{Time}", description: "Appointment time" },
  { tag: "{AppointmentType}", description: "Appointment type" },
  { tag: "{AppointmentLocation}", description: "Appointment location" },
  { tag: "{GroupName}", description: "Study group name" },
];
